import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const listExpedientes = () => api.get("/expedientes").then(r => r.data);
export const getExpediente = (id) => api.get(`/expedientes/${id}`).then(r => r.data);
export const createExpediente = (data) => api.post("/expedientes", data).then(r => r.data);
export const updateExpediente = (id, data) => api.put(`/expedientes/${id}`, data).then(r => r.data);
export const deleteExpediente = (id) => api.delete(`/expedientes/${id}`).then(r => r.data);
export const duplicateExpediente = (id) => api.post(`/expedientes/${id}/duplicate`).then(r => r.data);
export const uploadPhoto = (id, slot, data) => api.post(`/expedientes/${id}/photo`, { slot, data }).then(r => r.data);
export const deletePhoto = (id, slot) => api.delete(`/expedientes/${id}/photo/${slot}`).then(r => r.data);
export const getExpedientePhotos = (id) => api.get(`/expedientes/${id}/photos`).then(r => r.data);
export const getConfig = () => api.get("/config").then(r => r.data);
export const updateConfig = (data) => api.put("/config", data).then(r => r.data);

// Auth
export const authStatus = () => api.get("/auth/status").then(r => r.data);
export const authSetup = (data) => api.post("/auth/setup", data).then(r => r.data);
export const authLogin = (role, pin) => api.post("/auth/login", { role, pin }).then(r => r.data);
export const authLogout = () => api.post("/auth/logout").then(r => r.data);
export const authMe = () => api.get("/auth/me").then(r => r.data);
export const updatePins = (data) => api.put("/auth/pins", data).then(r => r.data);

// Oficio de Autorización (parseo automático)
export const parseAutorizacion = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/expedientes/${id}/parse-autorizacion`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then(r => r.data);
};
export const applyAutorizacion = (id, extracted) =>
  api.post(`/expedientes/${id}/apply-autorizacion`, { extracted }).then(r => r.data);

export const documentUrl = (id, doc_type) => `${API}/expedientes/${id}/document/${doc_type}`;
export const documentDocxUrl = (id, doc_type) => `${API}/expedientes/${id}/document/${doc_type}/docx`;
